import Shop from './Shop';

export default class Script {

	static read (room, script) {

		let run = room.run;

		switch (script.type) {
		case "shop":
			room.shop = new Shop(run, script);
			room.shop.fill(script.articles);
			if (script.special)
				room.shop.addSlotMachine();
			break;
		case "choice":
			room.setChoices(script.text, script.choices);
			break;
		}
	}
}